export const errorMessages = {
  required: 'Email is required',
  pattern: 'Email is invalid',
  notAvailable: 'Email is already in use',
};

export const emailDisabledInfo =
  'To change an email address, deactivate this employee and re-add the employee using the new email address. Remember to add the employee back to the group(s) that they were originally in. Contact your CSM for questions.';
